import { Outlet } from "react-router";

export function ProcessesBaseDataRoute() {
  return <Outlet />;
}
